<template>
  <AppBurgerMenu class="card-modal__mobile-menu">
    <template #menu-content>
      <CardModalSidebarLinks :drive-folder="card.drive_folder" />
      <CardModalSidebarActions :card="card" />
    </template>
  </AppBurgerMenu>
</template>

<script>
// Components
import AppBurgerMenu from 'Ui/AppBurgerMenu'
import CardModalSidebarLinks from './CardModalSidebarLinks'
import CardModalSidebarActions from './CardModalSidebarActions'

export default {
  name: 'CardModalSidebar',

  components: {
    AppBurgerMenu,
    CardModalSidebarLinks,
    CardModalSidebarActions,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.card-modal__mobile-menu {
  margin-bottom: 20px;
}

.card-modal__mobile-menu >>> .app-burger-menu__content {
  display: grid;
}
</style>
